import {SWITCH_WORKSPACE,
  SwitchWorkspace,
  WorkspaceSwitcherAction
} from "../actions";


export interface IWorkspaceSwitcherState {
  workspaceName: string;
  switching: boolean;
  redirect: boolean;
}

const initialState: IWorkspaceSwitcherState = {
  switching: false,
  workspaceName: '',
  redirect: true
};

export function reducer(state: IWorkspaceSwitcherState = initialState, action: WorkspaceSwitcherAction): IWorkspaceSwitcherState {
  let payload: IWorkspaceSwitcherState;

  switch (action.type) {
    case SWITCH_WORKSPACE:
      payload = (<SwitchWorkspace>action).payload;

      return {
        ...state,
        switching: payload.switching,
        workspaceName: payload.workspaceName,
        redirect: payload.redirect
      };
  }

  return state;
}
